import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { generateFlightAwareUrl } from '../utils';

const FlightQRCode = ({ flightData, size = 80, fgColor = '#ffffff', bgColor = 'transparent' }) => {
  const flightAwareUrl = generateFlightAwareUrl(flightData);
  
  return (
    <a 
      href={flightAwareUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ 
        display: 'block',
        padding: '8px', 
        background: 'rgba(255,255,255,0.1)', 
        borderRadius: '8px',
        backdropFilter: 'blur(4px)',
        textDecoration: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
        e.currentTarget.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <QRCodeSVG
        value={flightAwareUrl}
        size={size}
        bgColor={bgColor}
        fgColor={fgColor}
        level="M"
        includeMargin={false}
      />
      <div style={{ 
        fontSize: '8px', 
        color: 'rgba(255,255,255,0.5)', 
        textAlign: 'center',
        marginTop: '4px',
        letterSpacing: '0.5px',
      }}>
        FLIGHTAWARE ↗
      </div>
    </a>
  );
};

export default FlightQRCode;
